export default {
  add_products: '+ Dodaj produkty',
};
